import { Box } from '@mui/material';

import type { CalendarEvent, Member } from '../types';
import { tint } from '../utils';

type MonthEventPillProps = {
  event: CalendarEvent;
  member?: Member;
  isSelected?: boolean;
  onClick: (event: CalendarEvent) => void;
};

const BLOCK_HATCH =
  'repeating-linear-gradient(45deg, #f0ede8, #f0ede8 2px, #e0ddd8 2px, #e0ddd8 4px)';
const OVERRIDE_HATCH =
  'repeating-linear-gradient(45deg, #fce8c8, #fce8c8 2px, #f5d89c 2px, #f5d89c 4px)';

export function MonthEventPill({ event, member, isSelected, onClick }: MonthEventPillProps) {
  const isSession = event.kind === 'session';
  const isBlock = event.kind === 'block';

  const sessionBg = member ? tint(member.color) : '#d8e2cc';
  const sessionBorder = member ? member.color : '#5e8f3e';

  const label = event.title ?? member?.name ?? event.kind;

  return (
    <Box
      component="button"
      onClick={(e) => {
        e.stopPropagation();
        onClick(event);
      }}
      sx={{
        display: 'block',
        width: '100%',
        textAlign: 'left',
        border: 'none',
        borderRadius: '3px',
        mb: '2px',
        padding: '2px 6px',
        fontSize: 10,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        cursor: 'pointer',
        fontFamily: 'inherit',
        outline: isSelected ? '2px solid #2a3a22' : 'none',
        outlineOffset: 1,

        ...(isSession && {
          background: sessionBg,
          color: '#2a3a22',
          borderLeft: `2px solid ${sessionBorder}`,
        }),
        ...(isBlock && {
          background: BLOCK_HATCH,
          color: '#888',
          fontStyle: 'italic',
        }),
        ...(!isSession &&
          !isBlock && {
            background: OVERRIDE_HATCH,
            color: '#8a6a20',
            fontStyle: 'italic',
          }),

        '&:hover': { filter: 'brightness(0.96)' },
      }}
    >
      {label}
    </Box>
  );
}
